import { render, staticRenderFns } from "./TBtn.vue?vue&type=template&id=343cbd5b&scoped=true&"
import script from "./TBtn.vue?vue&type=script&lang=js&"
export * from "./TBtn.vue?vue&type=script&lang=js&"
import style0 from "./TBtn.vue?vue&type=style&index=0&id=343cbd5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343cbd5b",
  null
  
)

export default component.exports